import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { CreateFileSource } from 'models/inputModels/CreateTaskRequest';

type VideoPlayerProps = {
    filepath: string;
    fileSource?: CreateFileSource;
};

export default function VideoPlayer({ filepath, fileSource = 'provider' }: VideoPlayerProps): JSX.Element {
    const src = fileSource === 'provider' ? `${DOCUMENTS_URL}/${filepath}` : filepath;
    return <video controls controlsList="nodownload" src={src} width="100%" />;
}
